import Unsplash from "unsplash-js";

const unsplash = new Unsplash({
  accessKey: "RTPhdEVZUBCidOHZAxP0G7Xeru9Dt8bqJ__12W_iwmY"
});

export default unsplash;
